<template>
    <div class="header">
        <div class="p_img">
            <img :src="organization_info.o2o_fuwu_organization_avatar_url"/>
        </div>
        <div class="p_info">
            <div class="tit mb-5">
                <em>{{o2o_fuwu_organization_type}}</em>
                <span class="name">{{organization_info.o2o_fuwu_organization_name}}</span>
            </div>
            <p class="server">服务次数：{{organization_info.o2o_fuwu_organization_serve_count}}</p>
        </div>
    </div>
</template>

<script>
export default {
  name: 'OrganizationDetailHeader',
  props: {
    organization_info: {}
  },
  computed: {
    o2o_fuwu_organization_type () {
      if (this.organization_info.o2o_fuwu_organization_type === 0) {
        return '个人'
      } else {
        return '企业'
      }
    }
  },
  methods: {

  }

}
</script>

<style scoped>
    .header{background: #fff;padding:0.8rem 0.6rem;border-bottom: 1px solid #e6e6e6;height:4rem;}
    .header .p_img{width:4rem;height:4rem;border-radius: 0.2rem;float:left;}
    .header .p_img img{width:100%;height:100%}
    .header .p_info{margin-left:4.5rem;}
    .header .p_info .tit{}
    .header .p_info .tit em{float:left;display: block;padding: 0.1rem 0.4rem;line-height:0.8rem;font-size:0.6rem;color: #fff;margin-right:0.2rem;background: #edba2e;border-radius:5rem;}
    .header .p_info .tit .name{font-size:0.9rem;line-height:1rem;}
    .header .p_info .server{color: #999;font-size:0.6rem;}
</style>
